export const getMinSelectedWarningText = (count: number) =>
  `At least ${count} item${count > 1 ? "s" : ""} must remain selected in the filter.`;
export const areArraysEqual = <TValue>(
  first: TValue[],
  second: TValue[]
): boolean => {
  if (first.length !== second.length) {
    return false;
  }

  return first.every((value, index) => value === second[index]);
};

export const ensureMinSelectedValues = <TValue>({
  selectedValues,
  allOptionValues,
  minOptionCount,
}: {
  selectedValues: TValue[];
  allOptionValues: TValue[];
  minOptionCount: number;
}): TValue[] => {
  if (
    minOptionCount === 0 ||
    allOptionValues.length === 0 ||
    selectedValues.length >= minOptionCount
  ) {
    return selectedValues;
  }

  const nextSelectedValues = [...selectedValues];
  const selectedValueSet = new Set(selectedValues);

  for (const value of allOptionValues) {
    if (nextSelectedValues.length >= minOptionCount) {
      break;
    }

    if (!selectedValueSet.has(value)) {
      nextSelectedValues.push(value);
      selectedValueSet.add(value);
    }
  }

  return nextSelectedValues;
};
